import { BookService } from "./../../shared/book.service";
import { Component, Input, OnInit } from "@angular/core";

declare let alertify: any;
declare let localforage: any;
declare let window: any;

@Component({
	selector: "app-dashboard",
	templateUrl: "./dashboard.component.html",
	styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
	listBook!: any[];

	constructor(private service: BookService) { }

	ngOnInit(): void {
		document.body.className = 'bl-page-dashboard';
		if(document.body.offsetWidth < 760) document.body.className = 'bl-view-mobile bl-page-dashboard';

		var booksOnline = this.service.getBooks();
		var products: any = (booksOnline as any).default;
		var listItem = [];
		for (const property in products) {
			listItem.push(products[property]);
		}
		this.listBook = listItem.map((item) => {
			return {
				// ...item,
				biletcategory: item.biletcategory,
				biletkeywords: item.biletkeywords,
				info: item.desc,
				code: item.code,
				category: item.label,
				background: window.__static + `/static/${item.code}/image/background_stretch.png`,
				url: window.__static + `/static/${item.code}/image/avatar.png`,
				routerLink: ['/main/list-category'],
				queryParams: {
					code: item.code
				}
			};
		});
	}
}
